<!-- 资源中心 -->
<template>
  <div class="resource-center">
    <div class="resource-center-title">资源中心</div>
    <div class="resource-center-left">
      <div class="resource-center-total">
        <!-- <div class="name">资源总数</div> -->
        <div class="number">{{resourceNumber}}</div>
        <div class="image">
          <div class="name">资源总数</div>
          <img :src="require('@/assets/images/qxdataboard/resource-img.png')" alt="">
        </div>
      </div>
      <div class="resource-center-visits">
        <!-- <div class="name">访问量</div> -->
        <div class="number">{{accessNumber}}</div>
        <div class="image">
          <div class="name">访问量</div>
          <img :src="require('@/assets/images/qxdataboard/resource-img.png')" alt="">
        </div>
      </div>
    </div>
    <div class="resource-center-pie">
      <div class="chart" id="resourceCenterId" v-show="!isShow"></div>
      <div class="chart-error" v-show="isShow">
          <div class="detail">
              <span class="detail">暂无数据</span>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getPlatformResourceStatAPI} from "@/service/api.js"
export default {
  name: 'resource-center',
  components: {
  },
  props:{
    //区域id
    regionId:{
      type:String,
      default:""
    },
    //区域平台类型
    regionType:{
      type:String,
      default:""
    },
    //省id
    provinceId:{
      type:String,
      default:''
    },
    //市id
    cityId:{
      type:String,
      default:''
    },
    //区id
    districtId:{
      type:String,
      default:''
    },
    //乡镇地址
    address:{
      type:String,
      default:''
    },
    //开始时间
    startTime:{
      type:String,
      default:""
    },
    //结束时间
    endTime:{
      type:String,
      default:""
    },
    //学校id
    schoolId:{
      type:String,
      default:""
    }
  },
  data() {
      return {
        resList:[],
        //资源总数
        resourceNumber:0,
        accessNumber:0,
        isShow:false
      }
  },
  watch:{
    startTime(){
      this.getPlatformResourceStat();
    },
    endTime(){
      this.getPlatformResourceStat();
    },
    schoolId(){
      this.getPlatformResourceStat();
    },
    address(){
      this.getPlatformResourceStat();
    }
  },
  methods: {
    /**
     * @name 初始化echarts图表
     */
    initEchart(){
      let _this=this;
      _this.resList = _this.resList.map((item)=>{
        return {
          ...item,
          name:`${item.title}  ${item.value}%  ${item.number}`
        }
      })
      let dataSource = _this.$echarts.init(
          document.getElementById('resourceCenterId')
      );
      const option = {
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0,0,0,.5)",
          borderWidth: 0,
          padding: 20,
          textStyle: {
            color: "#fff",
          },
          formatter: (data) => {
            if (data.data.id == "all") {
              return data.data.title + "：100%";
            } else {
              return data.data.title + "：" + data.percent + "%";
            }
          },
        },
        legend: {
          orient: "vertical",
          left: "50%",
          top: "middle",
          icon: "circle",
          textStyle: {
            color: "#FFF",
            rich: {
              a: {
                align: "left",
                width: 100,
              },
              b: {
                align: "left",
                fontWeight: "bold",
                width: 100,
              },
            },
          },
          data:this.resList
        },
        series: [
          {
            type: "pie",
            radius: ["60%", "80%"],
            center: ["25%", "45%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
              formatter: (data) => {
                return (
                  "{a|" +
                  data.data.title +
                  "}" +
                  "\r\n" +
                  "{b|" +
                  data.data.number +
                  "}"
                );
              },
              rich: {
                a: {
                  fontSize: 14,
                  lineHeight: 30,
                  color: "#fff",
                  align: "center",
                },
                b: {
                  fontSize: 18,
                  lineHeight: 30,
                  fontWeight: "bold",
                  color: "#fff",
                  align: "center",
                },
              },
              backgroundColor: "transparent",
              fontWeight: "bold",
              fontSize: "15",
              padding: 6,
            },

            emphasis: {
              label: {
                show: true,
                fontSize: "15",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 2,
            },
            data: this.resList,
          },
        ],
      };
      dataSource.setOption(option);
      window.addEventListener("resize", function () {
          dataSource.resize();
      });
    },
    /**
     * @name 获取平台资源统计
     */
    getPlatformResourceStat(){
      let params = {
        regionId:this.regionId,
        startTime:this.startTime?`${this.startTime} 00:00:00` :'',
        endTime:this.endTime ? `${this.endTime} 23:59:59` :'',
        schoolId:this.schoolId,
        provinceId:this.provinceId,
        cityId:this.cityId,
        districtId:this.districtId,
        address:this.address,
        regionType:this.regionType
      }
      getPlatformResourceStatAPI(params).then((res)=>{
        this.accessNumber = res.rsViewNum;
        this.resourceNumber = res.rsNum;
        this.resList = [];
        let number = res.tpkRsNum + res.jtbkRsNum + res.zxkcRsNum + res.zhpsRsNum + res.wpfxRsNum + res.msgzsRsNum;
        //听评课
        this.resList.push({
          title:"听评课",
          value:Number((res.tpkRsNum/number*100).toFixed(2)) || 0,
          number:res.tpkRsNum,
          id:"1"
        });
        this.resList.push({
          title:"集体备课",
          value:Number((res.jtbkRsNum/number*100).toFixed(2)) || 0,
          number:res.jtbkRsNum,
          id:"2"
        });
        this.resList.push({
          title:"在线课程",
          value:Number((res.zxkcRsNum/number*100).toFixed(2)) || 0,
          number:res.zxkcRsNum,
          id:"3"
        });
        this.resList.push({
          title:"活动评选",
          value:Number((res.zhpsRsNum/number*100).toFixed(2)) || 0,
          number:res.zhpsRsNum,
          id:"4"
        });
        this.resList.push({
          title:"网盘分享",
          value:Number((res.wpfxRsNum/number*100).toFixed(2)) || 0,
          number:res.wpfxRsNum,
          id:"5"
        });
        this.resList.push({
          title:"名师工作室",
          value:Number((res.msgzsRsNum/number*100).toFixed(2)) || 0,
          number:res.msgzsRsNum,
          id:"6"
        })
        this.resList.sort(function(a, b) {
          return b.number - a.number;
        })
        this.initEchart();
      }).catch((err)=>{})
    }

  },
  mounted(){
    //获取平台资源统计
    this.getPlatformResourceStat();
  },
}
</script>

<style lang="scss" scoped>
.resource-center{
  width: 100%;
  height: 250px;
  background:url("~@/assets/images/qxdataboard/resource-bg.png") no-repeat ;
  background-size:100% 100%;
  display: flex;
  position: relative;
  align-items: center;
  .resource-center-title{
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    position: absolute;
    top:14px;
    left: 17px;
  }
  .resource-center-left{
    width: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 30px;
  }
  .resource-center-total{
    flex-direction: column;
    margin-top: 30px;
  }
  .resource-center-visits{
    margin-top: 30px;
    flex-direction: column;
  }
  .resource-center-total,
  .resource-center-visits{
    display: flex;
    align-items: center;
    justify-content: center;
    .number{
      color: #6ED1EC;
      font-size: 37px;
      font-family: MaravaleExpanded;
      font-weight: normal;
      color: #6FEFFF;
      line-height: 40px;
      @font-face {
        font-family: MaravaleExpanded;
        src: url('../../../assets/fonts/digifaw.ttf'); //字体路径
      }
    }
    .image{
      position: relative;
      .name{
        position: absolute;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #749AD7;
        top: 13px;
        left: 50%;
        transform: translateX(-50%);
      }
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .resource-center-pie{
    width: 50%;
    height: 200px;
    .chart{
      width: 100%;
      height: 100%;
    }
  }
}
</style>